import React from "react";
import DoYou from "../school/DoYou";
import OurCoreValue from "../school/OurCoreValue";
import AboutOurSchool from "../school/AboutOurSchool";
import Gallery from "../school/Gallery";
import OurSmarty from "../school/OurSmarty";
import TheOnlyWay from "../school/TheOnlyWay";
import BeyondThe from "../school/BeyondThe";
import Flexible from "../school/Flexible";

const School = () => {
  return (
    <div>
      <DoYou />
      <OurCoreValue />
      <AboutOurSchool />
      <OurSmarty />
      <TheOnlyWay />
      <BeyondThe />
      <Flexible />
      {/* <Belajar /> */}
      <Gallery />
      {/* <ContactSchool /> */}
    </div>
  );
};

export default School;
